import styled, { css } from 'styled-components';
import { gap } from '../../../../juristec-ui/styles/theme';

export const ManageStoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 1rem 1rem;
  /* max-width: 400px; */
  gap: 5px;
  & span.date {
    font-size: 14px;
    color: ${({ theme }) => theme.grey};
    align-self: end;
  }
  & span.errorMessage {
    position: absolute;
  }
  & span.special {
    font-size: 12px;
    color: ${({ theme }) => theme.grey};
  }
`;

export const TabGroup = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  & button {
    margin-bottom: 10px;
    margin-right: 5px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TabButton = styled.button`
  background-color: ${({ theme }) => theme.container};
  width: 100%;
  height: 45px;
  font-weight: bold;
  border: none;
  box-sizing: border-box;
  color: ${({ theme }) => theme.primary};
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  padding: 5px;
  & svg {
    fill: ${({ theme }) => theme.primary};
    height: 24px;
    width: 24px;
    margin-right: 5px;
  }
  & span {
    margin: auto;
  }
  & .icon-detail {
    transform: rotate(270deg);
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
      fill: ${({ theme }) => theme.container};
      margin: 0;
    }
  }
  ${({ theme, active, disabled }) => (active ? css`
    background-color: ${theme.secondary};
    color: ${theme.white};
    & svg {
      fill: ${theme.white};
    }
    & .icon-detail svg {
      fill: ${theme.white};
    }
  ` : css`
    &:hover {
      background-color: ${disabled ? theme.container : theme.selectHover};
      & .icon-detail svg {
        fill: ${theme.selectHover};
      }
    }
  `)}
`;

export const InfoText = styled.div`
  margin-bottom: 1rem;
`;

export const FrequencyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${gap('5px', 'row')};
`;

export const ScheduleFrequency = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.secondary};
`;

export const WarningMessage = styled.span`
  color: ${({ theme }) => theme.error};
`;
